<nav aria-label="Barra navegacion principal">
  <div class="barra-navegacion__izquierda">
    <div class="barra-navegacion__logo-container">
      <img class="barra-navegacion__logo-img" 
           [src]="imagenLogoFacto" 
           alt="Logo Facto"
           width="150"
           height="150"
           loading="eager"
           decoding="sync">
    </div>
  </div>
  
  <div class="barra-navegacion__centro">
    <div class="barra-navegacion__texto-container">
      <span class="barra-navegacion__texto-principal">{{ textoPrincipal }}</span>
      <img class="barra-navegacion__bandera" 
           [src]="imagenBandera" 
           alt="{{altBandera}}"
           width="36"
           height="24"
           loading="eager"
           decoding="sync">
    </div>
  </div>
  
  <div class="navbar-divider"></div>
  
  <div class="barra-navegacion__derecha">
    <div class="barra-navegacion__perfil">
      @if (usuarioEstaAutenticado) {
        <app-campana-notificaciones></app-campana-notificaciones>
      }

      <div>
        <span class="barra-navegacion__saludo">
          @if (usuarioEstaAutenticado) {
            ¡Hola {{ nombreMostrar() }}!
          } @else {
            ¡Hola Usuario!
          }
        </span>
        @if (usuarioEstaAutenticado && ultimoIngreso()) {
          <span class="barra-navegacion__ultima-conexion">
            Última conexión:<br>{{ ultimoIngreso() | formatoFecha:FORMATOS_FECHA.FECHA_HORA_12 }}
          </span>
        }
      </div>

      <span class="barra-navegacion__avatar">
        {{ usuarioEstaAutenticado ? iniciales() : 'U' }}
      </span>
      
      <div class="barra-navegacion__menu">
        <button class="barra-navegacion__desplegable" 
                type="button"
                title="Abrir menú de perfil"
                [attr.aria-expanded]="mostrarMenu()"
                [attr.aria-haspopup]="true"
                aria-label="Abrir menú de perfil de usuario"
                (click)="toggleMenu()"
                (keydown)="alPresionarTeclaMenu($event)"
                (keyup)="alSoltarTeclaMenu($event)">
          <i class="pi pi-chevron-down"></i>
        </button>
        
        @if (mostrarMenu()) {
          <div class="barra-navegacion__dropdown">
            @if (usuarioEstaAutenticado) {
              <div class="dropdown__item">
                <strong>{{ usuarioActual?.name }}</strong>
                {{ email() }}
              </div>
              <div class="dropdown__separator"></div>
              <button class="dropdown__button"
                  #menuItem
                  role="menuitem"
                  tabindex="0"
                  (click)="openColorSelector(); $event.stopPropagation()"
                  (keydown)="alNavegarMenu($event)">Cambiar color del rol</button>
              <div class="dropdown__separator"></div>
              <button class="dropdown__button"
                  #menuItem
                  role="menuitem"
                  tabindex="0"
                  (click)="logout(); closeMenu()"
                  (keydown)="alNavegarMenu($event)">Cerrar sesión</button>
              }
          </div>
        }
        @if (mostrarSelectorColor()) {
          <div class="barra-navegacion__panel-color" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <app-selector-color
              [colorActual]="colorActualRol()"
              [coloresOcupados]="coloresOcupados()"
              [rolNombre]="rolActualNombre()"
              (confirmarSeleccion)="onColorConfirmado($event)"
              (cancelar)="cerrarSelectorColor()">
            </app-selector-color>
          </div>
        }
      </div>
    </div>
  </div>
</nav>
